// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallTransferredActions_wrapper__3eqbO","buttons":"CallTransferredActions_buttons__3tdKw"};